module.exports = __webpack_public_path__ + "static/media/final4_500.5d9e044a.jpg";